import {
  getRemoteConfigBoolean,
  getRemoteConfigNumber,
  getRemoteConfigString,
  initializeRemoteConfig,
} from '@diamond/shared/utils';
import { useEffect, useState } from 'react';

export type RemoteConfigValues = {
  isReady: boolean;
  maintenanceMode: boolean;
  maintenanceMessage: string;
  featureSliderEnabled: boolean;
  sliderThrottleTime: number;
};

const defaultValues: Omit<RemoteConfigValues, 'isReady'> = {
  maintenanceMode: false,
  maintenanceMessage: "We're currently under maintenance. We'll be back soon!",
  featureSliderEnabled: true,
  sliderThrottleTime: 1000,
};

export const useRemoteConfig = (): RemoteConfigValues => {
  const [values, setValues] = useState<RemoteConfigValues>({
    isReady: false,
    ...defaultValues,
  });
  useEffect(() => {
    const loadRemoteConfig = async () => {
      try {
        await initializeRemoteConfig();

        setValues({
          isReady: true,
          maintenanceMode: getRemoteConfigBoolean('maintenance_mode'),
          maintenanceMessage: getRemoteConfigString('ff_web_test'),
          featureSliderEnabled: getRemoteConfigBoolean(
            'feature_slider_enabled'
          ),
          sliderThrottleTime: getRemoteConfigNumber('slider_throttle_time'),
        });

        console.log('Remote Config values set in state');
      } catch (error) {
        console.error('Error loading remote config:', error);
        setValues({
          isReady: true,
          ...defaultValues,
        });
      }
    };

    loadRemoteConfig();
  }, []);

  return values;
};
